import { FC, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'

import { dateFormat } from 'shared/lib/dateFormat'
import { IErrorForm, getFieldsError } from 'shared/lib/validate'
import { AllIcons } from 'shared/ui/app-icon/types'
import { ButtonIconText } from 'shared/ui/button-icon-text'
import { Button } from 'shared/ui/button/button'

import { checkExcursionsValidate } from './lib/checkExcursionsValidate'
import s from './styles.module.scss'

interface Props {
  isSearch?: boolean
  type?: 'white' | 'grey' | 'lightGrey'
  onSearch?: () => void
}

export const ExcursionsSearchForm: FC<Props> = observer(
  ({ type, onSearch }) => {
    const navigate = useNavigate()

    const [errors, setErrors] = useState<IErrorForm>()

    const { t } = useTranslation()

    const onClickDate = () => {
      navigate(RoutingPaths.excursion.calendar.path())
    }

    const onClickTo = () => {
      navigate(RoutingPaths.excursion.searchDirection.path())
    }

    const { departure_date, direction, name } =
      findExcursionsStore.findExcursions

    const resultDate = dateFormat(departure_date || '')

    const onValidate = async () => {
      try {
        await checkExcursionsValidate.validate(
          {
            departure_date,
            direction,
          },
          { abortEarly: false },
        )

        onSearch?.()
      } catch (error) {
        const resultValidate = getFieldsError(error)

        setErrors(resultValidate)
      }
    }

    return (
      <div>
        <div className={s.block}>
          <div className={s.field}>
            <ButtonIconText
              radius={16}
              type={type}
              height={'100%'}
              onClick={onClickTo}
              placeholder={t('to')}
              value={name || direction}
              error={!!errors?.['departure_date']}
            />
          </div>
        </div>

        <div className={s.block}>
          <div className={s.field}>
            <ButtonIconText
              radius={16}
              height={'100%'}
              type={type}
              value={resultDate}
              placeholder={t('when')}
              onClick={onClickDate}
              rightIcon={AllIcons.CALENDAR_NEW}
              error={!!errors?.['direction']}
            />
          </div>
        </div>

        <Button
          className={s.button}
          onClick={onValidate}
          borderRadius={'md'}
        >
          <p className={s.text}>{t('excursions.find_excursions')}</p>
        </Button>
      </div>
    )
  },
)
